import { render, staticRenderFns } from "./QuizzesDialog.vue?vue&type=template&id=647ef84a&scoped=true&"
import script from "./QuizzesDialog.vue?vue&type=script&lang=js&"
export * from "./QuizzesDialog.vue?vue&type=script&lang=js&"
import style0 from "./QuizzesDialog.vue?vue&type=style&index=0&id=647ef84a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647ef84a",
  null
  
)

component.options.__file = "QuizzesDialog.vue"
export default component.exports